import { render, staticRenderFns } from "./InputDescricao.vue?vue&type=template&id=0e68964b&"
import script from "./InputDescricao.vue?vue&type=script&lang=js&"
export * from "./InputDescricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports